module.exports = __webpack_public_path__ + "img/nav-design-fullsize@2x.d7e496e.jpg";